import React from 'react';
import Helmet from 'react-helmet';

import { toJS } from 'mobx';
import Moment from 'moment-timezone';

import { ReportBody } from '@/components/reports/body';
import { formatters } from '@Components/hierarchical-report/Layout';
import Configure from '@Components/hierarchical-report/configure';
import pathFinderStore from 'modules/report/stores/pathFinder';
import appStore from 'stores/app';

import Header from './components/Header';
import PathFinderResults from './components/PathFinderResults';
import { PathFinderReportProvider, usePathFinderReportStore } from './store'

class PathFinderLayout extends React.Component {
  state = {
    params: {
      startDate: Moment.tz(appStore.timezone).startOf("day"),
      endDate: Moment.tz(appStore.timezone).endOf("day"),
      filterby: {},
    },
  }

  configure = {
    filterby: {
      options: [{
        value: 'publisher',
        get label() {
          return <formatters.Loadable isLoading={pathFinderStore.publisher.isLoading}>Publisher</formatters.Loadable>
        },
        options: pathFinderStore.publisher.fetchData,
      }, {
        value: 'allocation',
        get label() {
          return <formatters.Loadable isLoading={pathFinderStore.allocation.isLoading}>Allocation</formatters.Loadable>
        },
        options: pathFinderStore.allocation.fetchData,
      }, {
        value: 'path',
        get label() {
          return <formatters.Loadable isLoading={pathFinderStore.path.isLoading}>Path</formatters.Loadable>
        },
        options: pathFinderStore.path.fetchData,
      }, {
        value: 'pathUserProfile',
        get label() {
          return <formatters.Loadable isLoading={pathFinderStore.pathUserProfile.isLoading}>Path User Profile</formatters.Loadable>
        },
        options: pathFinderStore.pathUserProfile.fetchData,
      }],
    },
  }

  loadData = async () => {
    pathFinderStore.fetchData(this.state.params).then(() => this.setState({}));
    this.setState({});
  }

  componentDidMount() {
    this.loadData()
  }

  handleChangeDates = ({ startDate, endDate }) => {
    this.setState(prevState => ({ params: { ...prevState.params, startDate, endDate } }), () => {
      if (startDate && endDate) {
        this.loadData();
      }
    });
  }

  handleChangeConfigure = state => {
    if (state.filterby) {
      state.filterby = Object.keys(state.filterby).reduce((filterby, field) => {
        const items = state.filterby[field].items.map(item => item.getValue())
        if (items.length > 0) filterby = { ...filterby, ...{ [field]: items } }
        return filterby
      }, {})
    }
    this.setState(prevState => ({ params: { ...prevState.params, filterby: state.filterby || {} } }), this.loadData)
    return state
  }

  handleChangeSelectConfigure = state => {
    this.setState(prevState => ({ params: { ...prevState.params, filterby: state.filterby || {} } }), this.loadData)
  }

  Configure = () => {
    const store = usePathFinderReportStore()
    const { report: { useLoad }, reportView } = store
    useLoad()

    const { filterby } = this.state.params
    if (this.configure) {
      return <Configure key='filter' store={reportView} configure={this.configure} onApply={this.handleChangeConfigure} onSelect={this.handleChangeSelectConfigure} value={{ filterby }} />
    }
    return null
  }

  render() {
    const { isLoading } = pathFinderStore.collection
    const searchData = toJS(pathFinderStore.collection.data);

    const data = searchData ? searchData.children : [];
    return (
      <PathFinderReportProvider>
        <Helmet title="Path Finder" />
        <Header
          onChangeDates={this.handleChangeDates}
          progressionType={this.state.progressionType}
          dates={{ startDate: this.state.params.startDate, endDate: this.state.params.endDate }}
          sync={this.loadData}
          isLoading={isLoading}
        >
          <this.Configure />
        </Header>
        <ReportBody contentClassName='p-4' loading={isLoading}>
          <PathFinderResults data={data} />
        </ReportBody>
      </PathFinderReportProvider>
    );
  }
}

export default PathFinderLayout;
